// js/top.js
import { playFadeIn } from "@/js/common/animation.js";

import { gsap, ScrollTrigger } from "@/js/common/gsap.js";

import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

/* =========================================
   FV Slider
========================================= */

function initTopFvSlider() {
  const slider = document.querySelector(".js-top-fv-slider");
  if (!slider) return;

  new Swiper(slider, {
    modules: [Autoplay, EffectFade],
    loop: true,
    effect: "fade",
    speed: 1100,
    allowTouchMove: false,

    autoplay: {
      delay: 4400,
      disableOnInteraction: false,
    },

    fadeEffect: {
      crossFade: true,
    },

    on: {
      init(swiper) {
        requestAnimationFrame(() => {
          swiper.el.classList.add("is-loaded");
        });
      },
    },
  });
}

/* =========================================
   Section Blur
========================================= */

function initSectionBlur() {
  const blur = document.querySelector(".js-section-blur");
  const sections = document.querySelectorAll("[data-blur-section]");

  if (!blur || sections.length === 0) return;

  gsap.set(blur, {
    opacity: 0,
  });

  sections.forEach((section) => {
    ScrollTrigger.create({
      trigger: section,
      start: "top bottom",
      end: "bottom bottom",

      onEnter: () => showBlur(),
      onLeave: () => hideBlur(),
      onEnterBack: () => showBlur(),
      onLeaveBack: () => hideBlur(),
    });
  });

  function showBlur() {
    gsap.to(blur, {
      opacity: 1,
      duration: 0.2,
      ease: "power3.out",
      overwrite: true,
    });
  }

  function hideBlur() {
    gsap.to(blur, {
      opacity: 0,
      duration: 0.2,
      ease: "power3.out",
      overwrite: true,
    });
  }
}

// /* =========================================
//    Action Parallax
// ========================================= */

// function initTopActionParallax() {
//   const action = document.querySelector(".p-top-action");
//   const container = document.querySelector(".p-top-action__container");

//   if (!action || !container) return;

//   gsap.fromTo(
//     container,
//     {
//       y: 80,
//     },
//     {
//       y: 0,
//       ease: "none",
//       scrollTrigger: {
//         trigger: action,
//         start: "top bottom",
//         end: "top center",
//         scrub: true,
//       },
//     },
//   );
// }

/* =========================================
   Team Parallax
========================================= */
function initTopTeam() {
  const section = document.querySelector(".js-top-team");
  const bg = document.querySelector(".js-top-team-bg");
  const lastMember = document.querySelector(".p-top-team__member--07");

  if (!section || !bg || !lastMember) return;

  ScrollTrigger.create({
    trigger: section,
    start: "top top",
    endTrigger: lastMember,
    end: "bottom center",
    pin: bg,
    pinSpacing: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
  });
}

/* =========================================
   Init
========================================= */

export function initTopPage() {
  initTopFvSlider();
  initSectionBlur();
  initTopTeam();
}
